<div class="spinner-background" *ngIf="spinner.isVisible() | async">
  <div class="loader">
    <div class="line"></div>
    <div class="line"></div>
    <div class="line"></div>
    <div class="line"></div>
  </div>
</div>
